const HistoryFileIcon = ({ width = '24', height = '24', color = '#111' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} color={color} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" /><path d="M8 14v2.2l1.6 1" /><circle cx="8" cy="16" r="6" /></svg>
    )
}

export default HistoryFileIcon